/**
 * Encore Foundation - 10.25.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Medium instead
 */
export const mobileBallad = {
  fontSize: '1rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Medium Bold instead
 */
export const mobileBalladBold = {
  fontSize: '1rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small instead
 */
export const mobileViola = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small Bold instead
 */
export const mobileViolaBold = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small instead
 */
export const mobileMesto = {
  fontSize: '0.8125rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Body Small Bold instead
 */
export const mobileMestoBold = {
  fontSize: '0.8125rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Headline Large instead
 */
export const mobileBass = {
  fontSize: '3.5rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 800,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Headline Medium instead
 */
export const mobileForte = {
  fontSize: '3rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Headline Medium instead
 */
export const mobileBrio = {
  fontSize: '2.5rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Marginal instead
 */
export const mobileFinale = {
  fontSize: '0.6875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Marginal Bold instead
 */
export const mobileFinaleBold = {
  fontSize: '0.6875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export const mobileMinuet = {
  fontSize: '0.625rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 400,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export const mobileMinuetBold = {
  fontSize: '0.625rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export const mobileMetronome = {
  fontSize: '0.875rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Large instead
 */
export const mobileAltoBrio = {
  fontSize: '2rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Large instead
 */
export const mobileAlto = {
  fontSize: '2rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Medium instead
 */
export const mobileCanon = {
  fontSize: '1.5rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Small instead
 */
export const mobileCelloCanon = {
  fontSize: '1.125rem',
  fontFamily:
    'var(--encore-title-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Title Small instead
 */
export const mobileCello = {
  fontSize: '1.125rem',
  fontFamily:
    'var(--encore-body-font-stack, var(--fallback-fonts, sans-serif))',
  fontWeight: 700,
};
